export const GET_TAXES = "GET_TAXES";
export const GET_TAXES_SUCCESS = "GET_TAXES_SUCCESS";
export const UPDATE_TAXES = "UPDATE_TAXES";
export const UPDATE_TAXES_FAILURE = "UPDATE_TAXES_FAILURE";
export const UPDATE_TAXES_SUCCESS = "UPDATE_TAXES_SUCCESS";



// WEBPACK FOOTER //
// ./src/components/dashboard/sales-taxes/salesTaxesActionTypes.js